export enum GenderEnum {
    male = 'male',
    female = 'female'
};